import { render } from "./tagEditor.vue?vue&type=template&id=7c6b3e84"
import script from "./tagEditor.vue?vue&type=script&lang=js"
export * from "./tagEditor.vue?vue&type=script&lang=js"

import exportComponent from "/home/adachi/omega-base/omega/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__